<template>
    <v-col
        :cols="width"
    >
        <v-label v-if="item.props.label">{{item.props.label}}</v-label>

        <v-radio-group
            :disabled="readonly"
            :row="item.props.row"
            :rules="rules"
            ref="input"
            v-bind:name="item.name"
            v-model="modelData"
            dense
            class="pa-0 ma-0"
        >
            <span v-if="item.props.radioIsInline && item.props.required" class="required"></span>

            <v-radio
                v-for="(thisItem, index) in item.props.items"
                :key="item.name + index"
                :label="thisItem.text"
                :value="thisItem.value"
                color="primary"
                :class="item.props.withDescription ? 'my-2 py-2 align-start' : item.props.row ? 'my-2 py-0 align-center' : 'my-2 py-0 align-start'"
            >
                <template v-if="item.props.withDescription" v-slot:label>
                    <div class="align-start" v-html="thisItem.text"></div>
                </template>
            </v-radio>

            <template v-if="item.props.tooltip" v-slot:append>
                <v-tooltip
                    top
                    max-width="620"
                >
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information</v-icon>
                    </template>
                    <div v-html="item.props.tooltip"></div>
                </v-tooltip>
            </template>

        </v-radio-group>
    </v-col>
</template>
<script>
    export default {
        name: 'RadioList',

        props: {
            item: Object,
            value: [String, Number],
            readonly: Boolean,
            rules: Array,
            width: [String, Number],
            handleTabChange: Function,
            openQuestionnaire: Function
        },

        computed: {
            modelData: {
                get: function () {
                    return this.value;
                },
                set: function (newVal) {
                    this.$emit('input', newVal);
                }
            }
        },

        methods: {
            validate: function () {
                return this.$refs.input.validate();
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    span.required::after {
        content: "*";
        color: #ff0000;
        margin-left: -0.3em;
        margin-right: 0.5em;
    }
</style>


// WEBPACK FOOTER //
// src/components/questionnaire_template/radio-list.vue